import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { LegalEntityDraftData, SelectedExistingEntity } from '../../utils/types';

export interface LegalEntityState {
  loader: boolean;
  legalEntityCategory: string | undefined;
  accountType: string | null;
  selectedEntity:SelectedExistingEntity ;
}

const initialState: LegalEntityState = {
  loader: false,
  legalEntityCategory: undefined,
  accountType: null,
  selectedEntity: {
    modelOpen:false
  },
};

export const legalEntitySlice = createSlice({
  name: 'legalEntity',
  initialState,
  reducers: {
    resetLegalEntity: () => initialState,
    setLoader: (state, action: PayloadAction<boolean>) => {
      state.loader = action.payload;
    },
    setLegalEntityCategory: (state, action: PayloadAction<string>) => {
      state.legalEntityCategory = action.payload;
    },
    setAccountType: (state, action: PayloadAction<string>) => {
      state.accountType = action.payload;
    },
    setSelectedEntity: (state, action: PayloadAction<SelectedExistingEntity>) => {
      state.selectedEntity = { ...state.selectedEntity, ...action.payload };
    },
    setEntityDraftData: (state, action: PayloadAction<LegalEntityDraftData>) => {
      state.legalEntityCategory = action.payload.legalEntityCategory;
      state.accountType = action.payload.accountType;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setLoader,
  resetLegalEntity,
  setLegalEntityCategory,
  setAccountType,
  setSelectedEntity,
  setEntityDraftData,
} = legalEntitySlice.actions;

export const selectLoader = (state: RootState) => state.legalEntity.loader;
export const selectLegalEntityCategory = (state: RootState) => state.legalEntity.legalEntityCategory;
export const selectLegalEntityState = (state: RootState) => state.legalEntity;
export const selectAccountType = (state: RootState) => state.legalEntity.accountType;
export const selectedExistingEntity = (state: RootState) => state.legalEntity.selectedEntity;

export default legalEntitySlice.reducer;
